import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
    .command-palette {
        font-size: 12px;
        font-family: monospace;
        z-index: 1000;
        position: fixed;
        top: 0;
        left: 50%;
        min-width: 300px;
        transform: translateX(-50%);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        background: #444;
        color: white;
        display: flex;
        flex-direction: column;

        &:not(.active) {
            display: none;
        }

        .search-bar {
            padding: 0 10px;
            input {
                font-family: monospace;
                width: 100%;
                padding:10px 0;
                background: #444;
                border: none;
           }
        }
        ul,
        li {
            list-style-type: none;
            margin: 0;
            padding: 0;
        }

        ul {
            display: flex;
            width: 100%;
            flex-direction: column;

            li {
                width: 100%;
                cursor: pointer;

                &:hover,
                &.active {
                    background: #555;
                }
                a {
                    color: #eee;
                    padding: 10px;
                    text-decoration: none;
                    width: 100%;
                    display: inline-block;
                }
            }
        }

    }
`